import * as Types from 'types';
import { fetchNextPage } from 'features/lists/actions';

import { requestArtworks, RequestArtworksProps } from 'features/artworks/api';
import { receiveArtworks } from 'features/artworks/actions';
import { setArtStreamArtworksFetching } from 'features/playlists/actions';

import { getArtStreamListForQuery, SUGGESTED_ARTWORKS_LIST } from './constants';

export const getArtStreamListId = (query: string) =>
  query === '' || query.length < 3 ? SUGGESTED_ARTWORKS_LIST : getArtStreamListForQuery(query);

export const fetchArtStreamList =
  (query: string): Types.DefaultThunkAction =>
  (dispatch) => {
    let listId = getArtStreamListId(query);

    const queryParams: RequestArtworksProps =
      listId === SUGGESTED_ARTWORKS_LIST
        ? { filter: 'available', perPage: 10, order: 'date', direction: 'desc' }
        : {
            filter: ['available', 'match'],
            match: query,
            perPage: 100,
            order: 'date',
            direction: 'desc',
            parentId: null,
          };

    dispatch(
      fetchNextPage(
        listId,
        () =>
          requestArtworks(queryParams).then((artworks) => {
            dispatch(setArtStreamArtworksFetching(false));
            dispatch(receiveArtworks(artworks));
            return artworks;
          }),
        { refresh: true },
      ),
    );
  };

let requestArtStreamListForQueryTimeout: number | undefined;
export const requestArtStreamListForQuery =
  (query: string): Types.DefaultThunkAction =>
  (dispatch) => {
    dispatch(setArtStreamArtworksFetching(true));
    requestArtStreamListForQueryTimeout && clearTimeout(requestArtStreamListForQueryTimeout);

    requestArtStreamListForQueryTimeout = window.setTimeout(() => {
      dispatch(fetchArtStreamList(query));
    }, 1000);
  };
